exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.control-label[data-v-31e82bef] {\n  font-weight: 700;\n}\n.overflow-wrap[data-v-31e82bef] {\n  overflow-wrap: anywhere;\n  height: fit-content;\n}\n.notes[data-v-31e82bef] {\n  border: none;\n  font-family: \"Roboto\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n}\n", ""]);

// exports
